import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'datezone',
    standalone: false
})
export class DatezonePipe implements PipeTransform {
	transform(value: any, timezone: any): any {
		return moment.tz(value, timezone).format('dddd Do MMMM YYYY');
	}
}
